import script from "./ChartDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartDialog.vue?vue&type=script&setup=true&lang=js"

import "./ChartDialog.vue?vue&type=style&index=0&id=2be60034&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be60034"]])

export default __exports__